import { useState } from "react";
import {
  createCookies,
  getCookies,
  updateCookies,
} from "../services/cookiesService";

export const useCookies = () => {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const createTheCookies = async (
    userId,
    functionalCookies,
    personalizationCookies,
    analyticsCookies,
    marketingCookies
  ) => {
    setIsLoading(true);

    setError(false);

    try {
      const response = await createCookies(
        userId,
        functionalCookies,
        personalizationCookies,
        analyticsCookies,
        marketingCookies
      );
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong while creating the Cookies.";
    }
  };

  const getTheCookies = async (userId) => {
    setIsLoading(true);
    setError(false);
    try {
      const response = await getCookies(userId);
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong while getting Cookies.";
    }
  };

  //   const deletCookies = async (tableId) => {
  //     setIsLoading(true);
  //     setError(false);
  //     try {
  //       const response = await deletTheTable(tableId);
  //       setIsLoading(false);
  //       return response;
  //     } catch (error) {updateTheTable
  //       setIsLoading(false);
  //       setError(true);
  //       return "Something went wrong while deleting the Cookies";
  //     }
  //   };

  const updateTheCookies = async (
    userId,
    functionalCookies,
    personalizationCookies,
    analyticsCookies,
    marketingCookies
  ) => {
    setIsLoading(true);
    setError(false);
    try {
      const response = await updateCookies(
        userId,
        functionalCookies,
        personalizationCookies,
        analyticsCookies,
        marketingCookies
      );
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong while updating Cookies";
    }
  };

  return {
    createTheCookies,
    getTheCookies,
    updateTheCookies,
    isLoading,
    error,
  };
};
